import { getBestMarketPricesTabFx } from '@/modules/mixing/store/analytical-mixing.store';
import { ANALYTICAL_MIXING_SELECTED_WAREHOUSE } from '@/shared/constants/local-storage-keys.constant';
import { fetchMixingAnalitycDataFx } from '@/widgets/analytics/model';
import { setRecalculateStoreInProcess } from '@/widgets/recalculate-indicator/store/root.store';
import {
  fetchTopRecipesForWarehouse,
  fetchWarehousesForMixingDataFx,
} from '@/widgets/recipe/model';
import { notification } from 'antd';
import { useStore } from 'effector-react';
import md5 from 'md5';
import {
  ACTIVE_BUYER,
  ACTIVE_BUYER_TYPE,
  SELLER_ACCOUNT_BUYERS_SORT,
} from '../constants';
import {
  $singleBuyerData,
  fetchBuyerByIdFx,
  fetchBuyersListFx,
} from '../store/buyers.store';
import { fetchBuyerOffersListFx } from '../store/offers.store';

export const offerExpiryEventHandler = async (updateData?: {
  id: number;
  price: string;
  class: string;
  sort: string;
  type: string;
  company: string;
}) => {
  const buyersListSortState = (() => {
    const val = localStorage.getItem(SELLER_ACCOUNT_BUYERS_SORT);
    if (val) return JSON.parse(val);
  })();
  //const user_id = localStorage.getItem('USER_ID');
  const activeBuyerId = localStorage.getItem(ACTIVE_BUYER);
  const activeBuyerData = (() => {
    const val = localStorage.getItem(ACTIVE_BUYER_TYPE);
    if (val) return JSON.parse(val);
    return null;
  })();
  const activeWhForAnalyticalMixing = (() => {
    const val = localStorage.getItem(ANALYTICAL_MIXING_SELECTED_WAREHOUSE);
    return val || null;
  })();

  const currentRoute = window.location.pathname;
  console.log('PUSHER EVENT TRIGGERED AND DATA UPDATED');

  // SELLER ACCOUNT OFFER EXPIRY HANDLER
  if (currentRoute === '/account/seller') {
    setRecalculateStoreInProcess(true);
    await fetchBuyersListFx(
      buyersListSortState
        ? {
            sortBy: buyersListSortState.options.find((item: any) => item.active)?.val,
            orderBy: buyersListSortState.orderBy,
            search: buyersListSortState.searchString,
            invisible: true,
          }
        : { search: '', invisible: true },
    ); //invisible
    if (activeBuyerId) {
      await fetchBuyerByIdFx({
        id: Number(activeBuyerId),
        md5:
          activeBuyerData.type === 'external'
            ? md5(activeBuyerData.company_name)
            : undefined,
      });
      await fetchBuyerOffersListFx({
        id: Number(activeBuyerId),
        disableLoadingStatus: true,
      }); // invisible
      //   PUBLIC_MODE === 'development' &&
      //     notification.info({ message: 'EVENT TRIGGERED AND DATA UPDATED' });
    }
  }

  // ANALYTICAL MIXING RECIPES OFFER EXPIRY HANDLER
  if (
    currentRoute === '/mixing/recipes-new'
    // ||
    // currentRoute === '/offer/contracts' ||
    // currentRoute === '/offer'
  ) {
    setRecalculateStoreInProcess(true);
    await fetchWarehousesForMixingDataFx({
      tons: Number(0),
      recipesCount: Number(0),
      mixAlgo: Number(0),
    });
    await getBestMarketPricesTabFx({ trade: true, moistureChangesDensity: true });
    activeWhForAnalyticalMixing &&
      (await fetchTopRecipesForWarehouse(Number(activeWhForAnalyticalMixing)));
    // PUBLIC_MODE === 'development' &&
    //   notification.info({ message: 'EVENT TRIGGERED AND DATA UPDATED' });
  }

  //  ANALYTICAL MIXING DASHBOARD OFFER EXPIRY HANDLER
  if (currentRoute === '/mixing') {
    await fetchMixingAnalitycDataFx();
    // PUBLIC_MODE === 'development' &&
    //   notification.info({ message: 'EVENT TRIGGERED AND DATA UPDATED' });
  }
  setRecalculateStoreInProcess(false);
};
